import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_GLOBAL_LLM_CONFIGURATION = 'GET_GLOBAL_LLM_CONFIGURATION';
export const GET_GLOBAL_LLM_CONFIGURATION_SUCCESS = 'GET_GLOBAL_LLM_CONFIGURATION_SUCCESS';
export const GET_GLOBAL_LLM_CONFIGURATION_FAIL = 'GET_GLOBAL_LLM_CONFIGURATION_FAIL';
export const GET_GLOBAL_LLM_CONFIGURATION_RESET = 'GET_GLOBAL_LLM_CONFIGURATION_RESET';

export const getGlobalLLMConfiguration = (params) => {
	return {
		type: GET_GLOBAL_LLM_CONFIGURATION,
		params,
	};
};

export const getGlobalLLMConfigurationSuccess = (response) => {
	return {
		type: GET_GLOBAL_LLM_CONFIGURATION_SUCCESS,
		response,
	};
};

export const getGlobalLLMConfigurationFail = (response) => {
	return {
		type: GET_GLOBAL_LLM_CONFIGURATION_FAIL,
		response,
	};
};

export const getGlobalLLMConfigurationReset = () => {
	return {
		type: GET_GLOBAL_LLM_CONFIGURATION_RESET,
	};
};

export const getGlobalLLMConfigurationApi = (params) => {
	return (dispatch) => {
		dispatch(getGlobalLLMConfiguration());
		axios
			.get(`${config.api.base_url}/global-llm-configuration`, {
				params: params,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getGlobalLLMConfigurationData = response.data;
				dispatch(getGlobalLLMConfigurationSuccess(getGlobalLLMConfigurationData));
			})
			.catch((error) => {
				const errorMsg = error.response?.data?.message || error.message;
				dispatch(getGlobalLLMConfigurationFail({ message: errorMsg }));
			});
	};
};

